module.exports = __webpack_public_path__ + "img/logo_org.dd2819de.png";